<template>
	<div class="home">
		<myheader></myheader>
		<homebody></homebody>
		<myfooter></myfooter>
	</div>
</template>

<script>
	import myheader from './myheader.vue'
	import homebody from './homebody.vue'
	import myfooter from './myfooter.vue'
	export default{
		name: 'home',
		components: {myheader, homebody, myfooter},
		data () {
			return {
				msg: 'aaa'
			}
		}
	}
</script>

<style>
	body{
/* 		display: flex;
		text-align: center; */
		width: 100%;
		height: 100%;
	}
</style>
